/**
 * Specifies the type of date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.
 * tag: 41139
 * @readonly
 * @enum {number} (int)
 */
export enum OptionExerciseDateType {
  /** Unadjusted */
  Unadjusted = 0,
  /** Adjusted */
  Adjusted = 1,
}
